export default "__VITE_ASSET__be68ea94__"